// ============================================================
// BRAND CONFIGURATION
// Edit this file to rebrand the store. No other files need
// to change for basic brand customization.
// ============================================================

import { localFontsUrl } from "./fonts";

const brand = {
  // ── Identity ────────────────────────────────────────────
  name: "Limitless",
  nameAccent: "Peptides",       // rendered in accent color after name
  tagline: "Research-grade compounds.",
  taglineEm: "compounds.",     // the italicized/accented portion of the tagline

  // ── Copy ────────────────────────────────────────────────
  heroEyebrow: "Members-only shop",
  heroDescription:
    "Limitless Peptides supplies research-grade peptides and compounds. Every product is third-party tested for purity. Fast shipping, transparent pricing.",
  shopEyebrow: "Research-grade",
  shopDescription:
    "Third-party tested peptides and compounds. Fast shipping, transparent pricing.",
  aboutHeading: "Why researchers\nchoose us",
  aboutBody1:
    "We carry a focused catalog of high-demand research compounds — each one verified for purity and identity before it ships. No fillers, no mystery sourcing, no corner-cutting.",
  aboutBody2:
    "Every batch is third-party tested and comes with documentation. If a product doesn't meet spec, we pull it. Quality control isn't a marketing line — it's how we operate.",
  shippingBadge: "Free shipping on orders over $200 · Ships in 2 business days",

  // ── Commerce ─────────────────────────────────────────────
  freeShippingThreshold: 200,   // dollars; set to Infinity to disable free shipping
  flatShippingRate: 10,          // dollars; shown when order is below threshold

  // ── Colors ──────────────────────────────────────────────
  colors: {
    bg:        "#111110",
    surface:   "#1a1a18",
    surface2:  "#222220",
    border:    "#2e2e2b",
    accent:    "#00d4aa",   // teal/cyan accent
    accentDim: "#00a888",
    text:      "#e8e6df",
    textDim:   "#8a8880",
    textMuted: "#555550",
    red:       "#d94040",
    green:     "#4a9e6a",
    radius:    "4px",
  },

  // ── Typography ───────────────────────────────────────────
  fonts: {
    // Self-hosted fonts (see src/fonts.js). "local:" lists bundled families.
    importUrl: localFontsUrl(["Playfair Display", "IBM Plex Mono", "Inter"]),
    display: "'Playfair Display', Georgia, serif",
    mono:    "'IBM Plex Mono', monospace",
    body:    "'Inter', 'Helvetica Neue', Helvetica, sans-serif",
  },
};

export default brand;
